import React from 'react';
import './index.css';

function WarningProgressBar () {
	return (
		<div className='warning-progress'>
			<div className='warning-progress__bar' />
		</div>
	)
}

export default WarningProgressBar;
